export default "__VITE_ASSET__12c6e318__"